<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <filter-dialog
          :dialog-visible="filterDialogVisible"
          :filter-label="filterLabel"
          :filter-stuff="filterStuff"
          @close="onCloseFilter"
          @filter="onSetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <header-dialog
          :dialog-visible="headerDialogVisible"
          :dialog-headers="dialogHeaders"
          @close="onCloseHeader"
          @header="onSetHeader"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col>
        <v-card>
          <v-card-text>
            <v-data-table
              no-data-text="Нет данных для отображения"
              :headers="headers"
              :items="items"
              :footer-props="datatable_footer"
            >
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <autocomplete
                          ref="autocomplete"

                          :get-result-value="getResultValue"
                          :search="search"
                          @submit="onSubmit"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-btn
                          color="primary"
                          outlined
                          @click="onOpenFilter"
                        >
                          <v-icon class="ml-3">
                            mdi-filter-variant
                          </v-icon>
                          <span class="mx-3">ФИЛЬТРЫ</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        class="d-flex justify-md-end"
                        cols="12"
                        md="6"
                      >
                        <v-tooltip
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              v-bind="attrs"
                              @click="onCreateItem"
                              v-on="on"
                            >
                              <v-icon class="ml-3">
                                mdi-plus
                              </v-icon>
                              <span class="mx-3">Добавить</span>
                            </v-btn>
                          </template>
                          <span>Создать новый атрибут</span>
                        </v-tooltip>
                        <v-icon
                          medium
                          class="icon-table"
                          @click="onOpenHeader"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                    </v-row>
                    <v-row>
                      <div>
                        <v-chip
                          v-for="(filter, index) in filterStuff"
                          v-show="filter.fieldValue !== '' && filter.fieldValue !== undefined"
                          :key="'i' + index"
                          close
                          @click:close="onClearFilter(filter)"
                        >
                          <span>{{ filter.fieldName }}: {{ filter.fieldValue }}</span>
                        </v-chip>
                      </div>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.actions="{ item }">
                <task-menu
                  @delete="onDeleteItem(item)"
                  @edit="onEditItem(item)"
                />
              </template>
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import TaskMenu from "@/views/loyalty/shared/components/task-menu/TaskMenu"
import { AttributeService } from "@/views/loyalty/shared/services/attribute_service"
import WebApi from "@/views/loyalty/shared/modules/web_api"
import Autocomplete from "@/views/loyalty/shared/components/search-autocomplete/Autocomplete"
import FilterDialog from "@/views/loyalty/shared/components/filter/FilterDialog"
import { FilterItem, FilterStuff } from "@/views/loyalty/shared/classes/filter_stuff"
import HeaderDialog from "@/views/loyalty/shared/components/header/HeaderDialog"
import { HeaderService } from "@/views/loyalty/shared/services/header_service"
import { AttributeHeadersModel } from "@/views/loyalty/models/attribute.model"

export default {
  name: "AttributeList",
  components: { HeaderDialog, FilterDialog, Autocomplete, TaskMenu },
  data: () => ({
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    filterDialogVisible: false,
    filterLabel: 'attribute.filter',
    filterStuff: [],
    headerDialogVisible: false,
    headers: [],
    headerService: null,
    dialogHeaders: [],
    items: [],
    // filterLabel: "attribute.filter",
    webApi: null,
  }),
  beforeMount () {
    const that = this
    localStorage.removeItem(this.filterLabel)
    this.webApi = new WebApi(this.$store).readError("Не удалось прочитать данные атрибутов")
    this.headerService = new HeaderService(AttributeHeadersModel)
    // this.headers = AttributeService.getHeaders()
    this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/header/attribute/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
        .then(function (data) {
          console.log('header data', data)
          that.dialogHeaders = that.headerService.get_header(data)
          console.log('that.dialogHeaders', that.dialogHeaders)
          that.headers = that.headerService.get_header_list(data)
          console.log('that.headers', that.headers)
        })
        this.fillFilterStuff()
  },
  async mounted () {
    this.items = await this.getItems()
  },
  methods: {
    fillFilterStuff () {
      this.filterStuff = new FilterStuff()
      this.filterStuff.add(new FilterItem().fieldName("Название").fieldValue("").fieldType("text").value)
      this.filterStuff.add(new FilterItem().fieldName("Мнемоника").fieldValue("").fieldType("text").value)
      this.filterStuff.add(new FilterItem().fieldName("Тип переменной").fieldValue("").fieldType("select").fieldValues([{ text: 'Строка', value: '0' }, { text: 'Число', value: '1' }, { text: 'Логический', value: '2' }]).value)
      this.filterStuff.add(new FilterItem().fieldName("Удалён").fieldValue("").fieldType("select").fieldValues([{ text: 'Нет', value: 'false' }, { text: 'Да', value: 'true' }]).value)
      this.filterStuff = this.filterStuff.items
      console.log('filterStuff', this.filterStuff)
      return this.filterStuff
    },
    getItems () {
      return this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/attributes/all`).then(data => {
        // console.log((new AttributeService()).item)
        return data.map(item => { return this.setItem(item) })
      })
    },
    getResultValue (result) {
      // console.log('getResultValue', result)
      return result.searched
    },
    onClearFilter (filter) {
      console.log('filter', filter)
      const attrFilter = JSON.parse(localStorage.getItem(this.filterLabel))
      const newFilter = attrFilter.filter(f => { if (f.fieldValue === filter.fieldValue) { f.fieldValue = ""; return true } else { return true } })
      console.log('newFilter', newFilter)
      localStorage.setItem(this.filterLabel, JSON.stringify(newFilter))
      this.onSetFilter()
    },
    onCloseFilter () {
      const filterStuff = JSON.parse(localStorage.getItem(this.filterLabel))
      console.log('const filterStuff', filterStuff)
      this.filterStuff = filterStuff || this.fillFilterStuff()
      console.log('onCloseFilter this.filterStuff', this.filterStuff)
      this.filterDialogVisible = false
    },
    onCloseHeader () {
      this.headerDialogVisible = false
    },
    onCreateItem () {
      this.$router.push({ name: "AttributeEditLink", params: { attributeId: '0' } })
    },
    onDeleteItem (item) {
      const that = this
      this.webApi
          .delete(`${process.env.VUE_APP_LOYALTY_URL}api/attribute/` + item.attributeId)
          .then(function (data) {
            console.log(data)
            if (data) {
              that.getItems()
            }
          })
    },
    onEditItem (item) {
      console.log('edit item', item)
      this.$router.push({ name: "AttributeEditLink", params: { attributeId: item.attributeId } })
    },
    onOpenFilter () {
      console.log('onOpenFilter this.filterStuff', this.filterStuff)
      this.filterDialogVisible = true
    },
    onOpenHeader () {
      const that = this
      this.headerDialogVisible = true
      this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/header/attribute/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
          .then(function (data) {
            console.log('header data', data)
            that.dialogHeaders = that.headerService.get_header(data)
          })
    },
    async onSetFilter () {
        // const attrFilter = JSON.parse(localStorage.getItem(this.filterLabel))
        this.filterStuff = JSON.parse(localStorage.getItem(this.filterLabel)) || ''
        // console.log('attrFilter', attrFilter)
        this.filterDialogVisible = false
        // this.filterStuff = new FilterStuff(attrFilter).items
        console.log('this.filterStuff', this.filterStuff)
        if (this.filterStuff.length > 0) {
          this.items = await this.getItems().then(data => {
 return data.filter(f =>
              (f.name.includes(this.filterStuff[0].fieldValue) || this.filterStuff[0].fieldValue.length === 0) &&
              (f.mnemonic.includes(this.filterStuff[1].fieldValue) || this.filterStuff[1].fieldValue.length === 0) &&
              (f.type.toString().includes(this.filterStuff[2].fieldValue) || this.filterStuff[2].fieldValue.length === 0) &&
              (f.deleted.toString().includes(this.filterStuff[3].fieldValue) || this.filterStuff[3].fieldValue.length === 0))
          })
        }
        console.log('this.items', this.items)
    },
    onSetHeader (value) {
      const that = this
      console.log('onSetHeader', value)
      this.dialogHeaders = value
      this.headerDialogVisible = false
      const headers = this.headerService.set_header("attribute", this.$store.state.client ? this.$store.state.client.id : "0", value)
      console.log('headers', headers)
      this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/header/`, headers)
      that.headers = that.headerService.get_header_list(headers)
    },
    onSubmit (result) {
      console.log('submit', result)
      const searching = result.searched ? result.searched : result
      console.log('submit -> searching', searching)
      if (searching.length !== 0) {
        this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/attribute/searched/${searching}`).then(data => {
          // console.log((new AttributeService()).item)
          this.items = data.map(item => (Reflect.construct(AttributeService, [item])).item)
          console.log('attributes', this.items)
        })
      } else {
        this.getItems()
      }
    },
    search (input) {
      console.log('search', input)
      if (input.length < 1) { return [] }
      return this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/attribute/search/${input}`).then(data => {
        console.log('data', data)
        return data

        // console.log('attributes', this.items)
      })
    },
    setItem (data) {
      return (Reflect.construct(AttributeService, [data])).item
    }

  }
}
</script>

<style scoped>
</style>
